import { render } from "./DeliveryDashboard.vue?vue&type=template&id=24eab7c6"
import script from "./DeliveryDashboard.vue?vue&type=script&lang=js"
export * from "./DeliveryDashboard.vue?vue&type=script&lang=js"

import "./DeliveryDashboard.vue?vue&type=style&index=0&id=24eab7c6&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__